import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {CiapListHeader} from './components/header/CiapListHeader'
import {KTCard} from '../../../../_metronic/helpers'
import { Horizontal } from './components/horizontal-stepper/Horizontal'
import { PhotoEditModal } from './parameter-edit-modal/PhotoEditModal'

const ChecklistList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <> 
        <KTCard>
        <CiapListHeader/>
           <Horizontal/>
           {itemIdForUpdate !== undefined && <PhotoEditModal/>}
        </KTCard>
 
    </>
  )
}

const CiapListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ChecklistList/>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {CiapListWrapper}
